export default __webpack_public_path__ + "static/media/Location-Yellow-24x24.f126dbef.svg";